<template>
  <v-main>
    <div id="capture" class="accent whatsapp-image" :style="fields.name.length > 20 ? 'font-size: 2.8em' : 'font-size: 3.2em'">
      <div class="primary d-flex justify-center" style="width: 100%; height: 100%; border-radius: 50%;">
        <div class="text-center" style="max-width: 65%;">
          <img src="@/assets/logo-whatsapp.png" class="mb-4" style="max-width: 100%; margin-top: 40%;" />
          <v-divider class="white my-4 mx-auto" style="opacity: 0.3; max-width: 60%;"></v-divider>
          <div class="white--text bold--text pt-4">
            {{ fields.name }}
          </div>
        </div>
      </div>
    </div>
    <v-container v-if="!loading">
      <v-toolbar class="elevation-0 mb-3 b-sm-0">
        <div class="pl-0 ml-n4">
          <span class="headline">{{ fields.name }}</span>
          <br />
          <span>{{ fields.event_date | moment('DD/MM/YYYY') }}</span>
          <v-chip v-if="fields.step === -1" class="ml-sm-2" small color="mute">Finalizada</v-chip>
          <v-chip v-else-if="fields.step === 0 && fields.activate" class="ml-sm-2" small color="success">Ativa</v-chip>
          <v-chip v-else-if="fields.step === 0" class="ml-sm-2" small color="secondary">Desabilitada</v-chip>
          <v-chip v-else class="ml-sm-2" small color="warning">Incompleta - Passo {{ item.step }}</v-chip>
        </div>
        <v-spacer></v-spacer>
        <div class="d-flex mr-n4 align-center">
          <v-btn text color="primary" :to="{ name: 'celebrationForm', params: { id } }">
            <v-icon left>mdi-pencil</v-icon> Editar
          </v-btn>
          <v-btn text color="primary" @click="downloadWhatsappImage">
            <v-icon left>mdi-download</v-icon> Whatsapp
          </v-btn>
          <v-menu offset-y v-model="reportsMenu" :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text color="primary">
                <v-icon>mdi-format-list-checks</v-icon> Relatórios <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <div class="px-4 pt-2 pb-2">
                <v-checkbox
                  v-model="useCustomAccount"
                  label="Usar outro id (Mongo)"
                  color="primary"
                  class="pa-0 ma-0"
                  hide-details
                ></v-checkbox>
                <v-text-field
                  v-if="useCustomAccount"
                  v-model="customAccountId"
                  label="Id da conta no Mongo"
                  class="pt-2"
                  outlined dense hide-details
                ></v-text-field>
              </div>
              <v-divider />
              <v-list-item v-if="reportAccountId && isBackoffice" @click="reportsMenu = false; modalCelebrationReport = true">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-printer</v-icon> Relatório Geral (PDF)</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId" @click="getReport('totals')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-sigma</v-icon> Totalizadores</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId" @click="getReport('invoices')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-excel-outline</v-icon> Faturas da turma</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId" @click="getReport('extract')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-excel-outline</v-icon> Extrato da turma</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId" @click="getReport('monthly-extract')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-excel-outline</v-icon> Extrato mensal da turma (por categoria)</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId && isBackoffice" @click="getReport('negotiations')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-excel-outline</v-icon> Listagem de renegociações da turma</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId" @click="getReport('charge')">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-excel-outline</v-icon> Gerar planilha para cobrança</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="reportAccountId && isBackoffice" :to="{ name: 'celebrationPresentation', params: { celebrationId: id }, query: customQuery }">
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-presentation</v-icon> Relatório Apresentação</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn v-if="fields.gateway_id" text color="primary" @click="detailsModal = fields.gateway_id">
            <v-icon>mdi-piggy-bank-outline</v-icon> Conta Heppi
          </v-btn>
          <v-btn v-if="fields.gateway_id" @click="copyToClipboard(fields.gateway_id)" color="primary" fab text small dark>
            <v-icon>mdi-code-tags</v-icon>
          </v-btn>
        </div>
      </v-toolbar>
      <div class="d-flex justify-start align-start flex-column flex-sm-row">
        <!-- <div v-if="fields.image" class="my-3 mr-3">
          <img :src="fields.image" class="preview-image" />
        </div> -->
        <div class="col pr-5">
          <div class="row pt-1">
            <div class="col">
              <small>Código</small>
              <br>
              <b>{{ fields.code }}</b>
            </div>
            <div class="col">
              <small>Multa</small>
              <br>
              <b>{{ fields.fine_for_delay }}%</b>
            </div>
            <div class="col">
              <small>Juros</small>
              <br>
              <b>{{ fields.daily_interest }}%</b>
            </div>
            <div class="col" style="white-space: nowrap">
              <small>Tx. Boleto / PIX</small>
              <br>
              <b>{{ fields.bank_slip === 'increment' ? 'Adicionado' : fields.bank_slip === 'decrement' ? 'Descontado' : 'Sem boleto' }}</b>
            </div>
            <div class="col" style="white-space: nowrap">
              <small>Tx. Cartão</small>
              <br>
              <b>{{ fields.credit_card === 'increment' ? 'Adicionado' : fields.credit_card === 'decrement' ? 'Descontado' : 'Sem cartão' }}</b>
            </div>
          </div>
          <div class="pt-1">
            <small>Descrição</small>
            <div v-html="fields.description"></div>
          </div>
        </div>
        <div class="col-auto d-flex no-wrap mt-4 mt-sm-0">
          <div class="ml-sm-5">
            <small>Meta geral</small>
            <br>
            <span class="title">{{ fields.goal | price }}</span>
            <br>
            <small>Saldo</small>
            <br>
            <span class="title">{{ fields.balance | price }}</span>
          </div>
          <div class="ml-sm-5">
            <small>Total Pago</small>
            <br>
            <span class="title">{{ fields.total_paid | price }}</span>
            <br>
            <small>Total atrasado</small>
            <br>
            <span class="title">{{ fields.total_late | price }}</span>
          </div>
        </div>
      </div>
      <br>
      <v-tabs
        v-model="tab"
        center-active
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab key="tab-details" href="#tab-details">Mais informações</v-tab>
        <v-tab key="tab-participants" href="#tab-participants">Participantes</v-tab>
        <v-tab key="tab-fundraisings" href="#tab-fundraisings">Arrecadações</v-tab>
        <v-tab key="tab-documents" href="#tab-documents">Estatuto</v-tab>
        <v-tab v-if="isBackoffice" key="tab-invoices" href="#tab-invoices">Faturas</v-tab>
        <v-tab key="tab-tickets" href="#tab-tickets">Chamados</v-tab>
        <v-tab v-if="fields.gateway_id" key="tab-outs" href="#tab-outs">Saídas</v-tab>

        <v-tab-item key="tab-item-details" value="tab-details">
          <v-tabs v-model="tabDetails" center-active>
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-notes" href="#tab-notes">Anotações</v-tab>
            <v-tab key="tab-drive" href="#tab-drive">Arquivos</v-tab>
            <v-tab-item key="tab-item-notes" value="tab-notes">
              <notes reference="celebration" :celebrationId="id"></notes>
            </v-tab-item>
            <v-tab-item key="tab-item-drive" value="tab-drive">
              <iframe v-if="driveFolder" :src="`https://drive.google.com/embeddedfolderview?id=${driveFolder}#list`" style="width:100%; min-height:400px; height: 50vh; padding-top: 16px; border:0;"></iframe>
              <div v-else class="pa-10 text-center">Ainda não tem uma pasta do drive vinculado</div>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>

        <v-tab-item key="tab-item-participants" value="tab-participants">
          <participants :celebration-id="id"></participants>
        </v-tab-item>

        <v-tab-item key="tab-item-fundraisings" value="tab-fundraisings">
          <fundraisings :celebration-id="id"></fundraisings>
        </v-tab-item>

        <v-tab-item key="tab-item-documents" value="tab-documents">
          <celebration-document :celebration-id="id"></celebration-document>
        </v-tab-item>

        <v-tab-item key="tab-item-invoices" value="tab-invoices">
          <invoices :celebration-id="id"></invoices>
        </v-tab-item>

        <v-tab-item key="tab-item-tickets" value="tab-tickets">
          <v-tabs v-model="tabTickets" center-active>
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-asana" href="#tab-asana">Asana</v-tab>
            <v-tab key="tab-huggy" href="#tab-huggy">Huggy</v-tab>
            <v-tab-item key="tab-item-asana" value="tab-asana">
              <ticket-list reference="celebration" :id="id" :asanaID="asanaID"></ticket-list>
            </v-tab-item>
            <v-tab-item key="tab-item-huggy" value="tab-huggy">
              Em breve
            </v-tab-item>
          </v-tabs>
        </v-tab-item>

        <v-tab-item v-if="fields.gateway_id" key="tab-item-outs" value="tab-outs">
          <v-tabs v-model="tabOuts" center-active>
            <v-tabs-slider></v-tabs-slider>
            <v-tab key="tab-withdraws" href="#tab-withdraws">Saques</v-tab>
            <v-tab key="tab-transfers" href="#tab-transfers">Pagto Fornecedor</v-tab>
            <v-tab-item key="tab-item-withdraws" value="tab-withdraws">
              <account-withdraws :accountId="fields.gateway_id"></account-withdraws>
            </v-tab-item>
            <v-tab-item key="tab-item-transfers" value="tab-transfers">
              <account-transfers :accountId="fields.gateway_id"></account-transfers>
            </v-tab-item>
          </v-tabs>
        </v-tab-item>
      </v-tabs>
    </v-container>
    <app-loading :visible="loading"></app-loading>
    <account-modal :accountId="detailsModal" @close="detailsModal = null"></account-modal>
    <v-dialog v-model="modalCelebrationReport" max-width="400">
      <v-card>
        <v-card-title class="headline">Gerar relatório</v-card-title>
        <v-card-text>
          <p>Você pode alterar o nome do documento se desejar:</p>
          <v-form ref="form" @submit.prevent>
            <v-text-field
              label="Nome do documento"
              v-model="report.title"
              outlined dense
            ></v-text-field>
            <p>A turma tem taxa heppi descontada? De quanto?</p>
            <v-text-field
              label="Taxa Heppi"
              v-model="report.heppiFee"
              outlined dense
            ></v-text-field>
            <p>O valor dos juros é diferente? (iugu, juros importado...)</p>
            <v-text-field
              label="Valor correto dos juros"
              v-model="report.interest"
              outlined dense
            ></v-text-field>
            <p>É para usar outra conta de base para as transferências? (promoover)</p>
            <v-text-field
              label="Conta dos detalhes"
              v-model="report.baseAccount"
              outlined dense
            ></v-text-field>
            <p>É para ignorar alguma transferencia? Colocar os ids separados por ","</p>
            <v-textarea
              label="Transferências para serem ignoradas"
              v-model="report.ignoreTransfers"
              outlined dense
            ></v-textarea>
            <p>O que vai aparecer no relatório?</p>
            <v-checkbox
              v-for="option in reportSectionOptions"
              :key="option.value"
              :value="option.value"
              :label="option.text"
              v-model="report.sections"
              color="primary"
              class="pa-0"
              hide-details
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="modalCelebrationReport = false">
            Fechar
          </v-btn>
          <v-btn
            color="success"
            :disabled="!report.title"
            text
            :to="{
              name: 'celebrationPrint',
              params: { celebrationId: id },
              query: {
                title: report.title,
                ...customQuery,
                ...(report.heppiFee || report.heppiFee === '0') ? { heppi_fee: parseFloat(report.heppiFee) } : {},
                ...(report.ignoreTransfers) ? { ignore_transfers: report.ignoreTransfers } : {},
                ...(report.baseAccount) ? { base_account: report.baseAccount } : {},
                ...(report.interest) ? { interest: parseFloat(report.interest) } : {},
                ...(report.sections) ? { sections: report.sections || [] } : {}
              }
            }"
          >
            Gerar documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import axios from 'axios'
import html2canvas from 'html2canvas'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import AppLoading from '@/components/Loading'

import Participants from '@/views/Participants/Participants'
import CelebrationDocument from '@/views/Celebrations/CelebrationDocument'
import Fundraisings from '@/views/Fundraisings/Fundraisings'
import Invoices from '@/views/Invoices/Invoices'
import Notes from '@/components/NoteList'
import TicketList from '@/components/TicketTabList'
import AccountModal from '@/components/AccountModal'
import AccountTransfers from '@/components/AccountTransfers'
import AccountWithdraws from '@/components/AccountWithdraws.vue'

export default {
  name: 'celebrationForm',
  components: {
    AppLoading,
    Participants,
    CelebrationDocument,
    Fundraisings,
    Invoices,
    Notes,
    TicketList,
    AccountModal,
    AccountTransfers,
    AccountWithdraws
  },
  props: ['id'],
  data: () => ({
    loading: false,
    tab: 'tab-details',
    tabDetails: 'tab-notes',
    tabTickets: 'tab-asana',
    tabOuts: 'tab-withdraw',
    fields: {
      name: '',
      description: '',
      code: '',
      gateway_id: null,
      step: 0,
      activate: false,
      image: null,
      event_date: '',
      balance: 0,
      goal: 0,
      total_late: 0,
      total_paid: 0,
      fine_for_delay: 0,
      daily_interest: 0,
      pix: '',
      bank_slip: '',
      credit_card: ''
    },
    asanaID: null,
    driveFolder: null,
    detailsModal: null,
    modalCelebrationReport: false,
    reportsMenu: false,
    useCustomAccount: false,
    customAccountId: '',
    report: {
      title: 'Resumo Financeiro',
      heppiFee: null,
      ignoreTransfers: null,
      baseAccount: null,
      interest: null,
      sections: []
    },
    reportSectionOptions: [
      { value: 'totals', text: 'Números totais' },
      { value: 'fundraisings', text: 'Arrecadações' },
      { value: 'cashback', text: 'Cashback' },
      { value: 'credits', text: 'Outros créditos (entradas de valor)' },
      { value: 'waivers', text: 'Desistências' },
      { value: 'withdraws', text: 'Resgates' },
      { value: 'transfers', text: 'Transferências' },
      { value: 'heppiPlan', text: 'Plano Heppi' }
    ]
  }),
  computed: {
    ...mapGetters(['isBackoffice']),
    // Id da conta usado nos relatórios: o da turma ou um do Mongo digitado na mão
    reportAccountId () {
      if (this.useCustomAccount) return (this.customAccountId || '').trim() || null
      return this.fields.gateway_id
    },
    customQuery () {
      return (this.reportAccountId && this.reportAccountId !== this.fields.gateway_id)
        ? { account: this.reportAccountId }
        : {}
    }
  },
  watch: {
    modalCelebrationReport (val) {
      if (val) {
        this.report.title = 'Resumo Financeiro'
        this.report.heppiFee = null
        this.ignoreTransfers = null
        this.baseAccount = null
        this.interest = null
        this.report.sections = ['totals', 'fundraisings', 'cashback', 'credits', 'waivers', 'withdraws', 'transfers', 'heppiPlan']
      }
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    getReport (type) {
      this.reportsMenu = false
      this.loading = true
      this.$store.dispatch('n8nApi', { method: 'GET', url: `94653405-8f0d-4b53-8460-d42d0310d1bd/${this.reportAccountId}/${type}` })
        .then(data => {
          // 1. Create a temporary URL pointing to the Blob object
          const url = URL.createObjectURL(data)

          // 2. Create a hidden <a> element
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = this.reportAccountId + '-' + type // Sets the default file name

          // 3. Append to DOM, trigger click, and remove it
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)

          // 4. Release the allocated memory after a short delay
          setTimeout(() => {
            URL.revokeObjectURL(url)
          }, 100)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadWhatsappImage () {
      const captureElement = document.getElementById('capture')
      html2canvas(captureElement).then(canvas => {
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = `${this.fields.name}.png`
        link.click()
      })
    }
  },
  created () {
    if (this.id) {
      let vue = this
      vue.loading = true

      axios.get('celebrations/' + vue.id)
        .then(response => {
          if (response.data) {
            vue.loading = false
            for (let key in vue.fields) {
              if (response.data && response.data[key]) vue.fields[key] = response.data[key]
            }
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.$router.push({ name: 'celebrations' })
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.push({ name: 'celebrations' })
        })

      this.$firestore.collection('settings').doc(vue.id).get()
        .then((snapshot) => {
          const data = snapshot.data()
          this.asanaID = (data && data.asana) || null
          this.driveFolder = (data && data.driveFolder) || null
        })
    }
  }
}
</script>
